import VerificationSuccessScene from './VerificationSuccessScene'
export default VerificationSuccessScene